var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { goalsStyle } from './Goals.style';
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks';
import GoalsTable from './GoalsTable';
import { clearGoals, getAllGoalsData, getGoalActionMap, getGoalsFail, getGoalsSuccess, resetGoals, updateGoalsPageNumber, } from 'store/goals/goals.action';
import withPaginationTable from 'hoc/withPaginationIsolated';
import { DIALOG_TYPES, PAGINATION_LIMIT } from 'globals/global.constants';
import { WellnessPlanContext } from '../wellnessPlanContext/WellnessPlan.context';
import { ADD_GOAL_CONTEXT, ADD_CUSTOM_GOAL_CONTEXT, GET_GOALS_CONTEXT, } from '../wellnessPlanContext/reducer';
import { PaginationFetchTypes, PAGINATION_TYPE } from 'globals/enums';
import { openDialog } from 'store/commonReducer/common.action';
var Goals = React.memo(function (_a) {
    var customerID = _a.customerID, selectedSeniorCareGiver = _a.selectedSeniorCareGiver, _b = _a.readOnly, readOnly = _b === void 0 ? false : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c;
    var classes = goalsStyle().classes;
    var dispatch = useAppDispatch();
    var _d = React.useContext(WellnessPlanContext), state = _d.state, dispatchContext = _d.dispatchContext;
    var isGoalsLoading = useAppSelector(function (state) { return state.goals.loading; });
    var page = useAppSelector(function (state) { return state.goals.currentPage; });
    var tableData = useAppSelector(function (state) { return state.goals.goalsRowsData; });
    var GOAL_FILTERS = ['active', 'archived', 'all'];
    var filterChangeRef = React.useRef(false);
    var _e = React.useState(false), isFetchingGoals = _e[0], setIsFetchingGoals = _e[1];
    // Memoize storage key to prevent unnecessary dependency changes
    var GOAL_FILTER_STORAGE_KEY = React.useMemo(function () { return "goals_filter_".concat(customerID); }, [customerID]);
    var getPersistedGoalFilter = React.useCallback(function () {
        var stored = localStorage.getItem(GOAL_FILTER_STORAGE_KEY);
        return stored === 'active' || stored === 'archived' || stored === 'all'
            ? stored
            : 'all';
    }, [GOAL_FILTER_STORAGE_KEY]);
    var _f = React.useState('all'), goalFilter = _f[0], setGoalFilter = _f[1];
    var _g = React.useState(false), isFilterInitialized = _g[0], setIsFilterInitialized = _g[1];
    var isLatestVersion = useAppSelector(function (state) { return state.wellnessPlan.isLatestVersion; });
    var currVersion = useAppSelector(function (state) { return state.wellnessPlan.currentVersion; });
    var isNewPlan = (tableData === null || tableData === void 0 ? void 0 : tableData.length) === 0 && goalFilter === 'all';
    // NOTE: filter tabs intentionally do NOT check `disabled` here — they
    // should stay clickable even when the section is paused/disabled, so the
    // user can still switch between Active/Archived/All to view data. Only
    // goal-mutating actions (Add Goal, Add Custom Goal) should be locked by
    // `disabled`.
    var isFilterDisabled = function (filter) {
        if (goalFilter === 'all' && isNewPlan) {
            return filter !== 'all';
        }
        return false;
    };
    // Initialize filter from localStorage only once
    React.useEffect(function () {
        if (!customerID || isFilterInitialized)
            return;
        var persistedFilter = getPersistedGoalFilter();
        setGoalFilter(persistedFilter);
        setIsFilterInitialized(true);
    }, [customerID, getPersistedGoalFilter, isFilterInitialized]);
    // Single source of truth: Fetch goals when customerID, currVersion, or goalFilter changes
    React.useEffect(function () {
        if (!customerID || !currVersion || !isFilterInitialized)
            return;
        setIsFetchingGoals(true);
        dispatch(updateGoalsPageNumber(1));
        dispatch(getAllGoalsData(customerID, currVersion, undefined, goalFilter)).then(function (goalsData) {
            if (goalsData) {
                dispatch(getGoalsSuccess(goalsData));
            }
        })
            .finally(function () {
            setIsFetchingGoals(false);
        });
    }, [customerID, currVersion, goalFilter, isFilterInitialized, dispatch]);
    React.useEffect(function () {
        if (!isFilterInitialized)
            return;
        dispatch(clearGoals()); // only rows
    }, [goalFilter, isFilterInitialized, dispatch]);
    // Fetch goal action map only when customerID changes (not on tableData changes)
    React.useEffect(function () {
        if (!customerID)
            return;
        dispatch(getGoalActionMap(customerID));
    }, [customerID, dispatch]);
    // Update context when tableData or filter changes
    React.useEffect(function () {
        var clearUnsavedGoals = filterChangeRef.current;
        dispatchContext({
            type: GET_GOALS_CONTEXT,
            payload: {
                data: tableData,
                isNewPlan: goalFilter === 'all' && tableData.length === 0,
                filter: goalFilter,
                clearUnsavedGoals: clearUnsavedGoals,
            },
        });
        if (clearUnsavedGoals) {
            filterChangeRef.current = false;
        }
    }, [tableData, dispatchContext, goalFilter]);
    // Cleanup on unmount
    React.useEffect(function () {
        return function () {
            dispatch(resetGoals());
        };
    }, [dispatch]);
    var performFilterChange = React.useCallback(function (filter) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (isNewPlan && filter !== 'all')
                return [2 /*return*/];
            if (filter === goalFilter)
                return [2 /*return*/];
            filterChangeRef.current = true;
            setGoalFilter(filter);
            localStorage.setItem(GOAL_FILTER_STORAGE_KEY, filter);
            return [2 /*return*/];
        });
    }); }, [goalFilter, isNewPlan, GOAL_FILTER_STORAGE_KEY]);
    var handleFilterChange = function (filter) {
        if (filter === goalFilter)
            return;
        var hasUnsavedGoals = state.goalsRowsData.some(function (row) { return row.isNewGoal; });
        if (hasUnsavedGoals) {
            dispatch(openDialog({
                boldMessage: 'You have unsaved goal changes. Are you sure you want to switch tabs? Your changes will be lost.',
                successButtonText: 'Confirm',
                type: DIALOG_TYPES.ADMIN_ACTION_DIALOG,
                isFailButton: true,
                onSuccessButton: function () {
                    performFilterChange(filter);
                },
            }));
            return;
        }
        performFilterChange(filter);
    };
    // HOC props
    var withPaginationProps = React.useMemo(function () {
        return {
            fetchType: PaginationFetchTypes.LAST_EVALUATED_KEY,
            dependency: false,
            paginationProps: {
                getData: function (_searchQuery, paginationKey) {
                    return getAllGoalsData(customerID, currVersion, paginationKey, goalFilter);
                },
                onSuccess: getGoalsSuccess,
                onError: getGoalsFail,
                onPageChange: updateGoalsPageNumber,
                // cacheKey: `${TABLE_CACHE_KEY.GOALS}-${seniorId}`,
                rowsPerPage: PAGINATION_LIMIT.goals,
                className: '',
                lastEvaluatedKeyPath: 'goals.lastEvaluatedKey',
                loadingPath: 'goals.loading',
                paginationType: PAGINATION_TYPE.SECONDARY,
                pagePath: 'goals.currentPage',
                tableData: __spreadArray([], state.goalsRowsData, true),
            },
        };
    }, [state.goalsRowsData, customerID, currVersion, goalFilter]);
    /**
     * @description Wrap component withPagination HOC to get the pagination service
     */
    var GoalsWithPagination = withPaginationTable(GoalsTable, { customerID: customerID, selectedSeniorCareGiver: selectedSeniorCareGiver, isFetchingGoals: isFetchingGoals, readOnly: readOnly, disabled: disabled }, withPaginationProps);
    var handleAddGoals = React.useCallback(function () {
        if (disabled)
            return;
        dispatchContext({ type: ADD_GOAL_CONTEXT });
        if (page !== 1) {
            dispatch(updateGoalsPageNumber(1));
        }
    }, [dispatchContext, page, dispatch]);
    var handleAddCustomGoal = React.useCallback(function () {
        if (disabled)
            return;
        dispatchContext({ type: ADD_CUSTOM_GOAL_CONTEXT });
        if (page !== 1) {
            dispatch(updateGoalsPageNumber(1));
        }
    }, [dispatchContext, page, dispatch]);
    var isDisableAddGoal = React.useMemo(function () {
        var _a, _b, _c;
        if (disabled)
            return true;
        if (goalFilter !== 'all')
            return true;
        if (!isLatestVersion)
            return true;
        if (state.goalsRowsData.length === 1 &&
            ((_a = state.goalsRowsData[0]) === null || _a === void 0 ? void 0 : _a.isNewGoal) &&
            !((_b = state.goalsRowsData[0]) === null || _b === void 0 ? void 0 : _b.goal) &&
            !((_c = state.goalsRowsData[0]) === null || _c === void 0 ? void 0 : _c.action)) {
            return true;
        }
        return state.goalsRowsData.some(function (row) { return !row.goal || !row.action; });
    }, [goalFilter, isLatestVersion, state.goalsRowsData]);
    return (_jsx(_Fragment, { children: _jsxs(Box, { className: classes.container, children: [_jsxs(Box, { className: classes.goalsHeader, sx: {
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        gap: 2,
                    }, children: [_jsxs(Typography, { component: 'div', className: classes.goalsTableHeading, variant: 'h6', style: { fontWeight: 500 }, children: ["Goals:", _jsx(Box, { component: 'span', className: classes.errorText, children: "*" })] }), _jsx(Box, { sx: {
                                position: 'relative',
                                display: 'flex',
                                flexWrap: 'wrap',
                                backgroundColor: '#e5e7eb',
                                borderRadius: '50px',
                                padding: '4px',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                                maxWidth: '100%',
                            }, children: GOAL_FILTERS.map(function (filter) {
                                var isDisabled = isFilterDisabled(filter);
                                return (_jsx(Button, { disabled: isDisabled || isGoalsLoading, onClick: function () { return handleFilterChange(filter); }, variant: "text", sx: {
                                        position: 'relative',
                                        px: 3,
                                        py: 1,
                                        fontSize: '0.875rem',
                                        fontWeight: 600,
                                        borderRadius: '50px',
                                        minWidth: '90px',
                                        transition: 'all 0.3s ease-in-out',
                                        backgroundColor: goalFilter === filter ? '#ffffff' : 'transparent',
                                        color: isDisabled
                                            ? '#9ca3af'
                                            : goalFilter === filter
                                                ? '#141F61'
                                                : '#6b7280',
                                        boxShadow: goalFilter === filter
                                            ? '0 2px 8px rgba(0, 0, 0, 0.15)'
                                            : 'none',
                                        transform: goalFilter === filter ? 'scale(1.05)' : 'none',
                                        cursor: isDisabled ? 'not-allowed' : 'pointer',
                                        '&:hover': {
                                            backgroundColor: isDisabled
                                                ? 'transparent'
                                                : goalFilter === filter
                                                    ? '#ffffff'
                                                    : 'transparent',
                                            color: isDisabled ? '#9ca3af' : '#374151',
                                        },
                                    }, children: filter.toUpperCase() }, filter));
                            }) }), _jsxs(Box, { display: 'flex', gap: 1, flexWrap: 'wrap', sx: {
                                width: { xs: '100%', md: 'auto' },
                                justifyContent: { xs: 'center', md: 'flex-end' },
                            }, children: [!readOnly && _jsx(Button, { variant: 'contained', color: 'primary', size: 'large', disabled: isDisableAddGoal || isFetchingGoals, onClick: handleAddCustomGoal, children: "Add Custom Goal" }), !readOnly && _jsx(Button
                                // className={globalClasses.smallButtonOutlined}
                                , { 
                                    // className={globalClasses.smallButtonOutlined}
                                    variant: 'contained', color: 'primary', size: 'large', disabled: isDisableAddGoal || isFetchingGoals, onClick: handleAddGoals, children: "Add Goal" })] })] }), _jsx(Box, { style: { height: '90%' }, children: GoalsWithPagination() })] }) }));
});
export default Goals;
